<div class="card">
  <p-table class="custom-table-container" [scrollable]="true" [scrollHeight]="scrollHeight" [autoLayout]="true"
    [rowHover]="true" [showGridlines]="true" [value]="reportRows" stripedRows>
    <ng-template pTemplate="header">
      <tr class="caption-container" #headerContainer>
        <th [attr.colspan]="dataReport.headers.length" class="p-0 border-0">
          <div class="card p-2" *ngIf="dataReport.captionDescription.length || dataReport.captionFilters.length">
            <div class="caption caption-description ">
              <span *ngFor="let description of dataReport.captionDescription">
                {{ description }}
              </span>
            </div>
            <div class="caption caption-filters">
              <span *ngFor="let filter of dataReport.captionFilters">
                {{ filter }}
              </span>
            </div>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <td class="p-0 border-0">
          <div class="dyn-row" [ngClass]="{
            'dyn-row-client': row.type === 'client',
            'dyn-row-cashReceipt': row.type === 'cashReceipt',
            'dyn-row-detail': row.type === 'detail'
          }" [ngStyle]="{ 'background-color': (row.type !== 'detail') && getBackgroundColor(row.depth) }">
            <div class="dyn-cell" *ngFor="let cell of row.cells" [ngStyle]="{ 'text-align': alignColumnText(cell) }">
              {{ cell }}
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>